// extracted by mini-css-extract-plugin
module.exports = {"projectTabs":"ProjectTabs_projectTabs__9Zv6x"};